module.exports = __webpack_public_path__ + "img/LiveTrackingHelp1.ef7d95d9.png";